import { render, staticRenderFns } from "./ClinicFdmDic.vue?vue&type=template&id=2b6485d5"
import script from "./ClinicFdmDic.vue?vue&type=script&lang=js"
export * from "./ClinicFdmDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicFdmDic.vue?vue&type=style&index=0&id=2b6485d5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6485d5')) {
      api.createRecord('2b6485d5', component.options)
    } else {
      api.reload('2b6485d5', component.options)
    }
    module.hot.accept("./ClinicFdmDic.vue?vue&type=template&id=2b6485d5", function () {
      api.rerender('2b6485d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicFdmDic.vue"
export default component.exports